import { Button, Descriptions, Dropdown, Popconfirm } from "antd";
import { useNavigate, useRouteLoaderData } from "react-router";
import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import BackTitle from "../common/BackTitle";
import { api } from "../common/api";

export default function DpiType() {
  const data = useRouteLoaderData("dpi");
  const navigate = useNavigate();

  return (
    <div style={{ width: "100%" }}>
      <BackTitle
        backEnabled={false}
        title="Dettagli categoria DPI"
        secondary={`ID: ${data.id}`}
        extra={
          <Dropdown
            trigger={["click"]}
            menu={{
              items: [
                {
                  key: "delete",
                  danger: true,
                  icon: <DeleteOutlined />,
                  label: (
                    <Popconfirm
                      title="Conferma rimozione"
                      description="L'operazione è irreversibile. Procedendo, i dati verranno rimossi definitivamente."
                      onConfirm={() => api.dpi.delete(data.id).then(() => navigate(".."))}
                    >
                      Elimina
                    </Popconfirm>
                  ),
                },
              ],
            }}
          >
            <Button aria-label="Azioni categoria DPI" icon={<MoreOutlined />} />
          </Dropdown>
        }
      />
      <Descriptions
        layout="vertical"
        column={3}
        colon={false}
        title={
          <>
            Informazioni generali
            <Button
              type="link"
              aria-label="Modifica categoria DPI"
              icon={<EditOutlined />}
              onClick={() => navigate("edit")}
            />
          </>
        }
        items={[
          { key: "name", label: "Nome", children: data.name },
          {
            key: "trackingType",
            label: "Tracciamento",
            children:
              { SERIAL: "Matricola", QUANTITY: "Quantità" }[data.trackingType] ?? data.trackingType,
          },
          {
            key: "requiredCourse",
            label: "Corso richiesto",
            children: data.requiredCourse?.title ?? "Nessuno",
          },
          {
            key: "inspectionMonths",
            label: "Revisione ogni",
            children: data.inspectionMonths != null ? `${data.inspectionMonths} mesi` : "",
          },
        ]}
      />
    </div>
  );
}
